import React from "react";
import extend from "lodash/extend";
import pick from "lodash/pickBy";
import identity from "lodash/identity";
import throttle from "lodash/throttle";
import Helmet from "react-helmet";
import {
  Card,
  CardMedia,
  CardTitle,
  CardText,
  CardActions,
  RaisedButton
} from "material-ui";
import moment from "moment-timezone";

import * as util from "../util";
import FilmList from "./partials/film-list/film-list.jsx";
import InjectedTenantHTML from "./partials/injected-tenant-html.jsx";
import ModeSwitcher from "./partials/mode-switcher.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import FilmStore from "../stores/FilmStore";
import FilmActions from "../actions/FilmActions";
import EventActions from "../actions/EventActions";
import WishlistStore from "../stores/WishlistStore";

class FilmGuide extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      query: {},
      isLoading: true
    };

    this._updateUrl = throttle(this._updateUrl.bind(this), 500);
    this._onStateChange = this._onStateChange.bind(this);
    this.getStyles = this.getStyles.bind(this);
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object.isRequired,
      tenant: React.PropTypes.object,
      isLarge: React.PropTypes.bool,
      isEmbed: React.PropTypes.bool
    };
  }

  static getStores() {
    return [FilmStore, WishlistStore];
  }

  static getPropsFromStores() {
    return FilmStore.getState();
  }

  componentWillMount() {
    FilmActions.fetchAll.defer();
    EventActions.fetchAll.defer({ includePastEvents: true });
    if (this.props.hasFetchedAll) {
      this.setState({ isLoading: false });
    }
    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      query: newProps.location.query
    });

    if (newProps.hasFetchedAll && this.state.isLoading) {
      setTimeout(() => this.setState({ isLoading: false }), 0);
    }
  }

  _updateUrl(query, stateOptions) {
    this.context.router.push({
      pathname: "/films",
      query: query,
      state: extend({ ignoreScrollBehavior: true }, stateOptions)
    });
  }

  _onStateChange(newState, stateOptions) {
    let query = extend({}, this.props.location.query, newState),
      nonEmptyQuery = pick(query, identity); // omit empty fields

    this.setState({ query: nonEmptyQuery }, () => {
      this._updateUrl(
        nonEmptyQuery,
        extend({ ignoreScrollBehavior: true }, stateOptions)
      );
    });
  }

  getStyles() {
    return {
      injectStyle: {
        marginTop: 10,
        fontSize: 16
      },
      smallInjectStyle: {
        paddingLeft: 10,
        paddingRight: 10
      }
    };
  }

  render() {
    var styles = this.getStyles(),
      injectStyle = Object.assign(
        {},
        styles.injectStyle,
        !this.context.isLarge && styles.smallInjectStyle
      ),
      { query } = this.state;

    if (!this.props.previewMode && !this.props.appSettings.film_guide_enabled) {
      let custom = this.context.tenant.film_guide_unreleased_custom.__html
        ? this.context.tenant.film_guide_unreleased_custom
        : this.context.tenant.schedule_unreleased_custom;
      return (
        <div className="Eventive--FilmGuidePage">
          <ModeSwitcher value="film-guide" />
          <div>
            {custom.__html ? (
              <InjectedTenantHTML style={injectStyle} content={custom} />
            ) : (
              <div
                style={Object.assign({}, injectStyle, { textAlign: "center" })}
              >
                The {this.context.tenant.display_film_guide} has not yet been
                released. Check back soon!
              </div>
            )}
          </div>
        </div>
      );
    }
    return (
      <div  className="Eventive--FilmGuidePage">
        <Helmet
          title={util.capitalize(this.context.tenant.display_film_guide)}
        />

        <ModeSwitcher events={this.props.events} value={"film-guide"} />

        {(!this.context.isEmbed ||
          this.props.location.query.showCustomContent) &&
        this.context.tenant.film_guide_custom.__html ? ( // Custom HTML is hidden when embedded
          <InjectedTenantHTML
            style={Object.assign({}, injectStyle, { marginBottom: 20 })}
            content={this.context.tenant.film_guide_custom}
          />
        ) : null}

        <FilmList
          films={this.props.films}
          hideFilterEditor={this.context.tenant.film_guide_hide_search}
          showLoadingIndicator={this.state.isLoading}
          search={query.search || ""}
          mode={query.mode || "grid"}
          starred={query.starred}
          filterTags={query.filterTags || {}}
          onStateChange={this._onStateChange}
          wishlistFilms={WishlistStore.getWishlistFilms()}
        />

        {this.context.tenant.marquee_enabled &&
        !this.props.hasFetchedAndForcedAll &&
        !(this.props.isFetchingAll && !this.props.isFetchingAllForced) ? (
          <div
            style={{
              textAlign: "center",
              marginTop: "2em",
              marginBottom: "2em"
            }}
          >
            <RaisedButton
              label={
                this.props.isFetchingAllForced
                  ? "Loading film archive..."
                  : "Show film archive"
              }
              disabled={this.props.isFetchingAllForced}
              onClick={() => FilmActions.fetchAll({ forceAll: true })}
              primary={true}
            />
          </div>
        ) : null}
      </div>
    );
  }
}

export default connectToStores(FilmGuide);



// WEBPACK FOOTER //
// ./src/app/components/films.jsx